export default function dealerColor(dealer) {
  if (dealer.attributes['active-status'] === 'Collection') {
    return 'text-fpx-red'
  } else if (dealer.attributes['active-status'] === 'Suspended') {
    return 'text-yellow'
  } else {
    return null
  }
}
